import { Link } from "react-router-dom";
import { useCookieConsent } from "@/components/privacy/CookieConsent";
import { APP_NAME } from "@/lib/constants";
import { Facebook } from "lucide-react";

const Footer = () => {
  const { openSettings } = useCookieConsent();

  return (
    <footer className="bg-white border-t border-slate-100 py-12 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-xl font-bold text-slate-900 mb-4">{APP_NAME}</h3>
            <p className="text-slate-500 max-w-sm mb-6">
              הפלטפורמה המובילה לגילוי, שיתוף וסקירת מערכות דיגיטליות חכמות.
              אנחנו מחברים בין יוצרים למשתמשים במקום אחד.
            </p>
            
            <div className="flex items-center gap-3">
              <a 
                href="https://www.facebook.com/profile.php?id=61583712172422" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-50 rounded-full flex items-center justify-center text-slate-600 hover:bg-[#1877F2] hover:text-white transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://wa.me/972525267239" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-50 rounded-full flex items-center justify-center text-slate-600 hover:bg-[#25D366] hover:text-white transition-all duration-300"
                aria-label="WhatsApp"
              >
                <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
              </a>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-slate-900 mb-4">ניווט מהיר</h4>
            <ul className="space-y-2">
              <li><Link to="/systems" className="text-slate-600 hover:text-primary transition-colors">קטלוג מערכות</Link></li>
              <li><Link to="/solutions" className="text-slate-600 hover:text-primary transition-colors font-medium text-blue-700">פתרונות למערכות</Link></li>
              <li><Link to="/about" className="text-slate-600 hover:text-primary transition-colors">אודות</Link></li>
              <li><Link to="/contact" className="text-slate-600 hover:text-primary transition-colors">צור קשר</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-slate-900 mb-4">משפטי</h4>
            <ul className="space-y-2">
              <li><Link to="/terms" className="text-slate-600 hover:text-primary transition-colors">תנאי שימוש</Link></li>
              <li><Link to="/privacy" className="text-slate-600 hover:text-primary transition-colors">מדיניות פרטיות</Link></li>
              <li><Link to="/cookies" className="text-slate-600 hover:text-primary transition-colors">מדיניות קוקיז</Link></li>
              <li>
                <button onClick={openSettings} className="text-slate-600 hover:text-primary transition-colors">
                  הגדרות קוקיז
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-100 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-400 text-sm">© {new Date().getFullYear()} {APP_NAME}. כל הזכויות שמורות.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;